module.exports = __webpack_public_path__ + "img/NG.7c79c823.svg";